import { Group } from "@mantine/core"
import { SuperAdminTalentTabs } from "src/components/superadmin/talent/SuperAdminTalentTabs"
import { EditSuperAdminTalentAction } from "src/components/superadmin/talent/SuperAdminTalentActions"
import { useAppState } from "src/state"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { SuperAdminTalentView } from "src/components/superadmin/talent/SuperAdminTalentView"

export function SuperAdminTalentOverlay() {

    const { currentItem } = useAppState(state=>state.users)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.dj_display}`} 
                    renderAction={ 
                        <Group gap="sm"> 
                            <EditSuperAdminTalentAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminTalentTabs overlay={true}/>
            <SuperAdminTalentView/>
        </DrawerPageLayout>
    )

}